import React, { useEffect } from "react";
import { useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import AdobeScript from "../../../../services/adobeScript";
import Layout from '../../global-elements/registration/layout';

function ApprovedMLA() {
  const brandSettings = useStoreState((state) => state.siteSettingsModel.brandSettings);
  const applicant = useStoreState((state) => state.applicantModel.applicant);
  const applicationResult = useStoreState((state) => state.applicationResultModel.applicationResult);
  const history = useHistory();
  const adobeAds = new AdobeScript();
  const websiteSettings = useStoreState(state => state.siteSettingsModel.websiteSettings);
  const isECSWelcomeScreenActive = Object.values(websiteSettings).find(ws => ws.Name === "ECSWelcomeScreenActive")?.Value || false;

  useEffect(() =>  {
    adobeAds.event('ApprovedPendfee')
  },[])

  useEffect(() => {
    return () => {
        if (history.action === 'POP') {
            history.go(1);
        }
    };
  }, [history]);

  return (
    <div className="container pendfee-container">
      <div className="row">
        <div className="col-lg-12 congratulations">
          <h2>Congratulations!</h2>
          <h3>
            You are approved for the {brandSettings.ProductName.toUpperCase()+'™'} Mastercard®, issued by {brandSettings.BankName} and serviced by Continental Finance Company.
          </h3>
      </div>
      <div className="instructions-text">
          <div className="font-weight-bold">
            <p>
              Thank you for your service to our country.
              Your account is covered by the Military Lending Act in which the required Processing Fee of ${applicationResult.security_deposit} will be waived.
              You should receive your credit card within 7-10 business days and can activate upon receipt for immediate use.
            </p>
          </div>
        </div>
      </div>
      <div className="row card-box">
        <div className="col-lg-6">
          <img src={brandSettings.CardImage} alt="" className="col-lg-12" />
        </div>
        <div className="col-lg-6 result-message">
          <div>
            <span className="credit-limit-number">
              ${applicationResult.credit_limit || "400"}
            </span>
            <span className="credit-limit-text">Credit Limit</span>
          </div>
          <div>
            <div className="attribute"> Approved Applicant: </div>
            <div>
              {applicant.FirstName || "Test"} {applicant.LastName || "Test"}
            </div>
          </div>
          <div>
            <div className="attribute">Your Reference Number: </div>
            <div>{applicationResult.ref_number || "16212152"}</div>
          </div>
        </div>
      </div>
      
      {isECSWelcomeScreenActive  && <Layout applicantId={applicationResult.ref_number} /> }
      
      <div className="instructions-text">
        <div className="font-weight-bold">Thank you and enjoy your new {brandSettings.ProductName.toUpperCase()} Mastercard!</div>
      </div>
    </div>
  );
}

export default ApprovedMLA;